import {
  EdgeTypes,
  NodeTypes,
  ReactFlowProps,
  SetCenterOptions,
} from "@xyflow/react";
import DefaultEdge from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/CustomReactFlow/Edges/DefaultEdge";
import RootNode from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/CustomReactFlow/Nodes/RootNode";
import Node from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Areas/Node";

export const nodeTypes: NodeTypes = {
  areaNode: Node,
  customRootNode: RootNode,
};

export const edgeTypes: EdgeTypes = { customEdge: DefaultEdge };

export const reactFlowSettings: ReactFlowProps = {
  nodeTypes,
  edgeTypes,
  minZoom: 0.3,
  defaultEdgeOptions: {
    style: { strokeWidth: 3, stroke: "#C6D4E3", borderRadius: 50, offset: 20 },
  },
  nodesConnectable: false,
  nodesDraggable: false,
  zoomOnScroll: true,
  zoomOnDoubleClick: false,
  panOnDrag: true,
  attributionPosition: "top-left",
  fitView: true,
  fitViewOptions: { maxZoom: 0.7 },
  onlyRenderVisibleElements: true,
  proOptions: { hideAttribution: true },
};

export const setCenterOptions: SetCenterOptions = {
  zoom: 1,
  duration: 700,
};
